import React from 'react';
import Card from '../components/Card';
import Button from '../components/Button';

const Pricing = () => {
    return (
        <>
            {/* Hero Section */}
            <section className="hero" style={{ minHeight: '60vh' }}>
                <div className="hero-content">
                    <h1 className="hero-title">Pricing & Plans</h1>
                    <p className="hero-subtitle">Flexible Options for Every Warrior's Journey</p>
                </div>
            </section>

            {/* Pricing Section */}
            <section className="section section-dark">
                <div className="section-header">
                    <h2 className="section-title">Choose Your Training Plan</h2>
                    <p style={{ textAlign: 'center', fontSize: '1.2rem', color: 'var(--color-gray-light)', maxWidth: '800px', margin: '1rem auto' }}>
                        All plans include live online classes, recorded session access, personalized feedback, and certification upon completion.
                    </p>
                </div>

                <div className="pricing-grid">
                    {/* Monthly Plan */}
                    <div className="pricing-card">
                        <h3 className="pricing-plan">Monthly</h3>
                        <div className="pricing-price">₹999</div>
                        <div style={{ fontSize: '1.1rem', color: 'var(--color-gold)', marginBottom: '1.5rem', fontWeight: '600' }}>/ $50 USD</div>
                        <p style={{ color: 'var(--color-gray-light)', marginBottom: '0.5rem' }}>per month</p>
                        <ul className="pricing-features">
                            <li>8 live classes per month</li>
                            <li>Full access to recorded sessions</li>
                            <li>Choose any 1 course</li>
                            <li>Personal progress tracking</li>
                            <li>WhatsApp support group</li>
                            <li>Certification on completion</li>
                            <li>Cancel anytime</li>
                        </ul>
                        <div style={{ marginTop: 'auto' }}>
                            <Button to="/registration" variant="secondary" style={{ width: '100%' }}>Select Plan</Button>
                        </div>
                    </div>

                    {/* Semi-annual Plan */}
                    <div className="pricing-card featured">
                        <span className="pricing-badge">Most Popular</span>
                        <h3 className="pricing-plan">Semi-annual</h3>
                        <div className="pricing-price">₹4,499</div>
                        <div style={{ fontSize: '1.1rem', color: 'var(--color-gold)', marginBottom: '1.5rem', fontWeight: '600' }}>/ $250 USD</div>
                        <p style={{ color: 'var(--color-gray-light)', marginBottom: '0.5rem' }}>for 6 months</p>
                        <ul className="pricing-features">
                            <li>48 live classes (6 months)</li>
                            <li>Full access to all recordings</li>
                            <li>Choose up to 2 courses</li>
                            <li>Personal progress tracking</li>
                            <li>Priority support</li>
                            <li>Certification on completion</li>
                            <li>Save significantly vs monthly</li>
                            <li>Free training equipment guide</li>
                        </ul>
                        <div style={{ marginTop: 'auto' }}>
                            <Button to="/registration" style={{ width: '100%' }}>Select Plan</Button>
                        </div>
                    </div>

                    {/* Annual Plan */}
                    <div className="pricing-card">
                        <span className="pricing-badge" style={{ background: 'var(--color-gold)' }}>Best Value</span>
                        <h3 className="pricing-plan">Annual</h3>
                        <div className="pricing-price">₹9,999</div>
                        <div style={{ fontSize: '1.1rem', color: 'var(--color-gold)', marginBottom: '1.5rem', fontWeight: '600' }}>/ $550 USD</div>
                        <p style={{ color: 'var(--color-gray-light)', marginBottom: '0.5rem' }}>per year</p>
                        <ul className="pricing-features">
                            <li>Complete year of training</li>
                            <li>Lifetime access to recordings</li>
                            <li>Access to ALL courses</li>
                            <li>1-on-1 monthly sessions</li>
                            <li>Personal video feedback</li>
                            <li>Advanced certification</li>
                            <li>Maximum savings</li>
                            <li>Free equipment recommendations</li>
                            <li>Competition training</li>
                            <li>Teaching certification eligible</li>
                        </ul>
                        <div style={{ marginTop: 'auto' }}>
                            <Button to="/registration" style={{ width: '100%' }}>Select Plan</Button>
                        </div>
                    </div>
                </div>
            </section>

            {/* What's Included Section */}
            <section className="section section-gradient">
                <div className="section-header">
                    <h2 className="section-title">What's Included in All Plans</h2>
                </div>
                <div className="cards-grid">
                    <Card icon="💻" title="Live Zoom Classes" text="Interactive training sessions with real-time instruction and feedback from expert instructors." />
                    <Card icon="📹" title="Recorded Sessions" text="Access to all class recordings so you can review techniques and practice at your own pace." />
                    <Card icon="🎓" title="Official Certification" text="Receive recognized certification upon successful completion of each course level." />
                    <Card icon="👨‍🏫" title="Expert Instruction" text="Learn from masters with 20+ years of experience in traditional Silambam training." />
                    <Card icon="👥" title="Community Support" text="Join a global community of students through WhatsApp groups and online forums." />
                    <Card icon="📊" title="Progress Tracking" text="Monitor your advancement with detailed progress reports and skill assessments." />
                </div>
            </section>

            {/* FAQ Section */}
            <section className="section section-dark">
                <div className="section-header">
                    <h2 className="section-title">Frequently Asked Questions</h2>
                </div>
                <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                    <Card className="mb-2">
                        <h3 className="card-title">What payment methods do you accept?</h3>
                        <p className="card-text">We accept UPI, credit/debit cards, net banking, and international payment methods through our secure payment gateway.</p>
                    </Card>
                    <Card className="mb-2">
                        <h3 className="card-title">Can I switch plans later?</h3>
                        <p className="card-text">Yes! You can upgrade your plan at any time. The price difference will be adjusted based on your remaining subscription period.</p>
                    </Card>
                    <Card className="mb-2">
                        <h3 className="card-title">Is there a refund policy?</h3>
                        <p className="card-text">We offer a 7-day money-back guarantee for new students. If you're not satisfied within the first week, we'll provide a full refund.</p>
                    </Card>
                    <Card className="mb-2">
                        <h3 className="card-title">Do I need any equipment to start?</h3>
                        <p className="card-text">For beginners, you can start with a simple wooden stick or PVC pipe. We'll provide detailed equipment recommendations after enrollment.</p>
                    </Card>
                    <Card className="mb-2">
                        <h3 className="card-title">How many classes per week?</h3>
                        <p className="card-text">Monthly plan includes 2 classes per week. You can choose your preferred batch timing during registration.</p>
                    </Card>
                    <Card className="mb-2">
                        <h3 className="card-title">Can I attend from anywhere in the world?</h3>
                        <p className="card-text">Absolutely! Our online classes are accessible globally. We have students from India, USA, UK, Singapore, and many other countries.</p>
                    </Card>
                </div>
            </section>

            {/* CTA Section */}
            <section className="section section-gradient" style={{ textAlign: 'center', padding: '5rem 2rem' }}>
                <h2 style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>Start Your Training Today</h2>
                <p style={{ fontSize: '1.3rem', marginBottom: '2rem', color: 'var(--color-gold-light)' }}>
                    Choose a plan and take the first step toward becoming a Silambam warrior.
                </p>
                <div className="btn-group">
                    <Button to="/registration" style={{ fontSize: '1.2rem', padding: '1.2rem 3rem' }}>Register Now</Button>
                    <Button to="/contact" variant="secondary" style={{ fontSize: '1.2rem', padding: '1.2rem 3rem' }}>Contact Us</Button>
                </div>
            </section>
        </>
    );
};

export default Pricing;
